import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../Modal/Modal';

/*
const listUrlsFidelityPrograms = [
  { id: 5, url: 'https://tudoazul.voeazul.com.br/web/azul/forgot-password' },
  { id: 4, url: 'https://www.smiles.com.br/login' },
  { id: 3, url: 'https://www.pontosmultiplus.com.br/login' },
  { id: 24, url: 'https://www.aeroplan.com/recover/reset-password' },
  { id: 10, url: 'https://login.flyingblue.com/login/account' },
  { id: 14, url: 'https://www.aa.com/loyalty/needPasswordAccess' },
  { id: 17, url: 'https://www.avios.com/av/en_gb/my-account/forgotten-my-password' },
  { id: 25, url: 'https://www.copaair.com/en/web/gs/forgot' },
  { id: 8, url: 'https://www.delta.com/user-login/resetPassword' },
  { id: 19, url: 'https://www.emirates.com/account/english/login/forgot_membership_password.aspx' },
  { id: 15, url: 'https://ssl.lan.com/cgi-bin/password_recovery/step1.cgi' },
  { id: 2, url: 'https://www.lifemiles.com/reset-password' },
  { id: 18, url: 'https://www.singaporeair.com/kfResetPIN-flow.form' },
  { id: 21, url: 'https://www.flytap.com/pt-br/login' },
  { id: 23, url: 'https://www.united.com/ual/en/us/account/security/passwordrecovery' },
]
*/

const ModalForgotPassword = ({ show, closeModal, linkPasswordRecovery }) => {
  return (
    <Modal
      show={show}
      fixed
      height={500}
      width={470}
      title="Recuperação de senha"
      description={
        <div>
          <p className="modal-forgot-password--text">Para recuperar sua senha no programa de fidelidade, siga as orientações abaixo:</p>
          <ul className="modal-forgot-password--guidelinesList">
            <li>
              <span>
                <a onClick={() => window.open(linkPasswordRecovery, '_blank')}>
                  Clique aqui
                </a> e acesse a área de login do seu programa de fidelidade.
              </span>
            </li>
            <li>Clique em “Esqueci minha senha”, informe seu CPF e o e-mail cadastrado no programa.</li>
            <li>Você receberá um e-mail do programa para fazer a alteração da sua senha.</li>
            <li>Depois da alteração, atualize sua senha de acesso no cadastro da sua oferta na MaxMilhas.</li>
          </ul>
        </div>
      }
      confirm="Ok, entendi"
      onConfirm={() => closeModal('forgotPassword', false)}
    />
  )
}

ModalForgotPassword.propTypes = {
  linkPasswordRecovery: PropTypes.string,
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
}

export default ModalForgotPassword